import { render, staticRenderFns } from "./SalesTable.vue?vue&type=template&id=60a2cd0f&"
import script from "./SalesTable.vue?vue&type=script&lang=js&"
export * from "./SalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a2cd0f')) {
      api.createRecord('60a2cd0f', component.options)
    } else {
      api.reload('60a2cd0f', component.options)
    }
    module.hot.accept("./SalesTable.vue?vue&type=template&id=60a2cd0f&", function () {
      api.rerender('60a2cd0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/SalesTable.vue"
export default component.exports